<template>
  <div>
    <el-dialog :visible.sync="dialogVisible" width="400px" center>
      <el-tabs v-model="activeName" @tab-click="handleClick1">
        <el-tab-pane label="短信登录" name="message">短信登录</el-tab-pane>
        <el-tab-pane label="密码登录" name="pass">密码登录</el-tab-pane>
      </el-tabs>
      <el-form :model="form" v-if="messShow">
        <el-form-item>
          <el-input v-model="form.name" auto-complete="off" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="form.name" auto-complete="off" placeholder="请输入短信验证码"></el-input>
        </el-form-item>
      </el-form>
      <div v-else-if="passShow"></div>
      <p>还没有账号？<a>立即注册</a></p>
      <el-button type="info" round>登录</el-button>
      <span slot="footer" class="dialog-footer">
        <p>其他登陆方式</p>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'ttxl-header-login',
  props: {
    loginShow: {
      type: Boolean
    }
  },
  data () {
    return {
      dialogVisible: false,
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },
      messShow: true,
      passShow: false,
      activeName: 'message'
    }
  },
  created () {
    console.log('this.loginShow', this.loginShow)
  },
  methods: {
    handleClick1 (e) {
      if (e.name === 'message') {
        this.messShow = true
        this.passShow = false
      } else if (e.name === 'pass') {
        this.messShow = false
        this.passShow = true
      }
    }
  },
  watch: {
    loginShow (newVal, oldValue) {
      this.dialogVisible = newVal
      console.log('newVal', newVal)
      console.log('oldValue', oldValue)
    }
  }
}
</script>
<style lang="stylus">
</style>



// WEBPACK FOOTER //
// src/components/header/login/index.vue